import React, { useCallback } from 'react';
import styled from 'styled-components';

import type { IShift } from './types';

import { BaseShift, ScheduleOfferModal } from '@/components/agent/my-schedule';

const Shift = ({
  block,
  blockColor,
  contract,
  isVisible,
  showLabelOnVTO,
  modal,
  onClick,
  isDlsBlocked,
  day,
}: IShift): React.ReactElement => {
  const shiftModal = useCallback(
    (parentRef, ref, handleClose) => (
      <ScheduleOfferModal
        contract={contract}
        blockColor={blockColor}
        block={block}
        isOffered={false}
        ref={ref}
        parentRef={parentRef}
        handleClose={handleClose}
      />
    ),
    [block, blockColor, contract],
  );
  return (
    <ShiftContainer
      blockColor={blockColor}
      block={block}
      onClick={onClick}
      contract={contract}
      modal={modal ? modal : shiftModal}
      isVisible={isVisible}
      isDlsBlocked={isDlsBlocked}
      day={day}
    >
      {showLabelOnVTO && contract.scheduleNameShort}
    </ShiftContainer>
  );
};

export { Shift };

const ShiftContainer = styled(BaseShift)<{ isVisible: boolean }>`
  &&& {
    ${props =>
      !props.isVisible &&
      `
      visibility: hidden;
    `}
  }
`;
